$(function($){
  /******************* MENU ************************/
  $(".nav-trigger").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".menu-bar").toggleClass("off-canvas");
    e.preventDefault();
  });

  $('.menu-bar').on("click", ".mega-dropdown > a > span", function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).parent().next('.menu-dropdown').slideToggle(800);
    $(this).toggleClass('ion-plus ion-minus');
  });
  $('.menu-bar').on("click", "a.level1 > span", function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).parent().next('.level-three-wrap').slideToggle(800);
    $(this).toggleClass('ion-plus ion-minus');
  });
  /******************* MENU ************************/

  /******************* SEARCH POPUP ************************/
  $(".search-toggle").on('click', function (e) {
    $(".header-wrap").toggleClass('search-active');
    e.preventDefault();
  });
  /******************* SEARCH POPUP ************************/

  /******************* FOOTER MENU ************************/
  $('body').on('click', '.f-box .f-title', function() {
    $(this).toggleClass('open');
    $(this).find('i').toggleClass('ion-plus ion-minus');
    $(this).closest('.f-box').toggleClass('footListCol');
    $(this).closest('.f-box').children('.foot-col-data').slideToggle(600);
  });
  /******************* FOOTER MENU ************************/

  /******************* SIDEBAR FILTER ACCORDION ************************/
  $('.sidebar-wrap').on("click", ".categories-size", function(e) {
    $(this).next('.categories-content').slideToggle(600);
    $(this).find('span').toggleClass('ion-plus ion-minus');
  });
  /******************* SIDEBAR FILTER ACCORDION ************************/

  /******************* MOBILE SIDEBAR FILTER POPUP ************************/
  if ($(window).width() < 769) {
    filter_popup();
    $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
  }
  $(window).on('resize', function(){
    if ($(window).width() < 769) {
      filter_popup();
      $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
    }
    else {
      $('.sidebar-sec').removeClass('mfp-hide');
      $('.mfp-content .sidebar-sec').addClass('mfp-hide');
    }
  });

  function filter_popup() {
    if($('.mob-filter').length) {
      $('.mob-filter').magnificPopup({
        delegate: 'a',
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function () {
            this.st.mainClass = this.st.el.attr('data-effect');
          }
        },
        midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
      });

      $('.sidebar-sec').addClass('mfp-hide');
    }
  }
  /******************* MOBILE SIDEBAR FILTER POPUP ************************/

  /******************* HOME BANNER SLIDER ************************/
  $('.main-banner').slick({
    //lazyLoad: 'ondemand',
    //speed: 800,
    dots: true,
    arrows: false,
    adaptiveHeight: true
  });
  $('.main-banner').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(window).trigger('resize');
  });
  /******************* HOME BANNER SLIDER ************************/

  /******************* CLOSE MENU AND SEARCH WHEN CLICK OUTSIDE ************************/
  $(document).on("click", function(e) {
    if($(e.target).closest('.menu-bar').length===0 && $(e.target).closest('.mobile-visible.mobile-menu-trigger-wrap').length===0 && !$(e.target).parent().hasClass('nav-trigger')) {
      $("body").removeClass('off-canvas-body');
      $(".menu-bar").removeClass("off-canvas");
    }

    if($(e.target).closest('.search-popup').length===0 && $(e.target).closest('.search-toggle').length===0 && !$(e.target).parent().hasClass('head-searc-wrap')) {
      $(".header-wrap").removeClass('search-active');
    }
  });
  /******************* CLOSE MENU AND SEARCH WHEN CLICK OUTSIDE ************************/

  /******************* CLICK ON SWATCH AND CHANGE IMAGE IN GRID ************************/
  $('.item-swatch .sin-img-swatch-wrap .inner-swatch-wrapper').click(function(){
    $(this).closest('.sin-img-swatch-wrap').siblings().removeClass('active');
    $(this).closest('.sin-img-swatch-wrap').addClass('active');
    var newImage = jQuery(this).closest('.sin-img-swatch-wrap').find('.hide img').attr('src');
    $(this).closest('.coverchgful').find('.img-effect > img.first_img').attr({ src: newImage });
    return false;
  });
  /******************* CLICK ON SWATCH AND CHANGE IMAGE IN GRID ************************/

  /******************* NEW ARRIVALS AND BEST SELLERS ************************/
  $('.new-arrival-slider-wrap').slick({
    lazyLoad: 'ondemand',
    autoplay: false,
    dots: false,
    arrows: true,
    centerMode: false,
    slidesToShow: 4,
    slidesToScroll: 1,
	infinite: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  /******************* NEW ARRIVALS AND BEST SELLERS SLIDER ************************/

  /******************* CUSTOMER REVIEW SLIDER ************************/
  $('.customers-review-slider').slick({
    autoplay: false,
    dots: false,
    arrows: true,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  /******************* CUSTOMER REVIEW SLIDER ************************/

  /******************* SERVICE SLIDER ************************/
  $('.service-wrap').slick({
    autoplay: false,
    dots: false,
    arrows: false,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }
    ]
  });
  /******************* SERVICE SLIDER ************************/

  /******************* EQUAL HEIGHT ************************/
  $(window).on('load', function() {
    equalheight('.product-title a');
    equalheight('.product-title');
    //equalheight('.match-custom-cat');
  });

  $(window).on('resize', function() {
    equalheight('.product-title a');
    equalheight('.product-title');
    //equalheight('.match-custom-cat');
  });
  /******************* EQUAL HEIGHT ************************/

  /******************* PRODUCT PAGE SLIDER ************************/
  $('.shop-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true
  });

  $('.shop-slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    centerMode: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false
        }
      }, 
      {
        breakpoint: 371,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false
        }
      }
    ]
  });

  var get_img = '';
  $('.template-product').on('click', '.product-single__thumbnail', function(e) {
    e.preventDefault();
    e.stopPropagation();
    get_img = $(this).data('thumbnail-id');
    $(".shop-slider .slick-slide").each(function () {
      var current_slide_img = $(this).find('img').data('custom-img-id');
      if (get_img == current_slide_img) {
        var get_current_slide_no = $(this).data('slick-index');
        $('.shop-slider').slick('slickGoTo', get_current_slide_no);
      }
    });
  });
  /******************* PRODUCT PAGE SLIDER ************************/

  /******************* PRODUCT PAGE TABBING ************************/
  $('body').on('click', '.prd-sin-title-wrap', function() {
    if(!$(this).hasClass('active')) {
      $(this).closest('.product-tabs-heading').find('.prd-sin-title-wrap').removeClass('active');
      $(this).closest('.product-tabs').find('.product-tabs-content').find('.prd-sin-content-wrap').removeClass('active');
      $(this).closest('.product-tabs').find('.product-tabs-content').find('.prd-sin-content-wrap').slideUp(800);
      $(this).addClass('active');
      var get_tab_no = $(this).data('tab-number');
      $(this).closest('.product-tabs').find('.product-tabs-content').find('.prd-sin-content-wrap').each(function() {
        if($(this).data('tab-number') == get_tab_no) {
          $(this).addClass('active');
          $(this).slideDown(800);
        }
      });
    }
  });
  /******************* PRODUCT PAGE TABBING ************************/

  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      var check_links = links[i].href;
      if(links[i].href != 'javascript:void(0);') {
        if(links[i].href != "javascript:iwishSharePopupNew('email')" && links[i].href != "javascript:iwishSharePopupNew('fb')" && links[i].href != "javascript:iwishSharePopupNew('twt')") {
          links[i].target = '_blank';
          links[i].rel = 'noreferrer noopener';
        }
      }
    }
  }

  $('body').on('click', '.prd-shop-look-wrap a', function() {
    if($('.shop-the-look-container.stl .stl__products').find('li').length) {
      $('.shop-the-look-container.stl').slideToggle(800);
    }
  });

  $('body').on('click', '.stl-content .close', function() {
    $('.shop-the-look-container.stl').slideUp(800);
  });

  $(window).on('load', function() {
    setTimeout(function() {
      //console.log($('.shop-the-look-container.stl .stl__products').html());
      if($('.shop-the-look-container.stl .stl__products').length) {
        if($('.shop-the-look-container.stl .stl__products').html().trim() == '') {
          $('.prd-shop-look-wrap').addClass('look-hidden');
        }
        else {
          $('.prd-shop-look-wrap').removeClass('look-hidden');
        }
      }
    }, 1200);
  });

  $('body.template-product').on('change', '.swatch :radio', function() {
    if($('.template-product .product-form__cart-submit').html().toLowerCase().indexOf("sold out") !== -1){
      setTimeout(function() {
        $('.iStock-wrapper').slideDown(600);
      }, 1000);
    }
    else{
      setTimeout(function() {
        $('.iStock-wrapper').slideUp(600);
      }, 1000);
    }
  });
  
  $('body').on('change','.swatch :radio',function(){
    var get_btn_text = $(this).closest('form').find('.prod-button>.btn.product-form__cart-submit span[data-add-to-cart-text]').html();
    if(get_btn_text.toLowerCase().trim() == 'sold out'){
      if($(this).closest('form').find('#BIS_trigger').length){
        if(!$(this).closest('form').find('#BIS_trigger').is(':visible')){
          $(this).closest('form').find('#BIS_trigger').slideDown(800);
        }
      }
    }
    else{
      $(this).closest('form').find('#BIS_trigger').slideUp(800);
    }
  });
});